import React, { Component } from "react";
import {  Col, Grid, Row } from "react-bootstrap";
import styles from "./Styles.module.css"
import BasicFilterSelect from "../v2/common/BasicFilterSelect";

class FilterForm extends Component {

    render (){
        let{companies, onChange}=this.props;

        return (
                <Grid>
                    <Row className={styles.filterFormContainer}>
                        <Col className={`inbox-context-menu ${styles['mb5']}`} md={3}>

                            <BasicFilterSelect
                                placeholder={'Select organization'}
                                options={companies}
                                onChange={onChange}
                                listBoxHeight={380}
                            />
                        </Col>
                    </Row>
                </Grid>
        );
    }
}

export { FilterForm }